export default {"src":"/_next/static/media/aithority.74223ac8.svg","height":33,"width":146,"blurWidth":0,"blurHeight":0};